import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/Button/Button';
import Checkbox from '../../../../../components/Checkbox/Checkbox';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { selectProject } from '../../../selector/conversion';
import './Materials.scss';
import FormikMaterial from './ModalMaterial/FormikMaterial';
import { FormikSubsector } from './ModalSubsector/FormikSubsector';

const Materials = () => {
    const { t } = useTranslation();
    const project = useAppSelector(selectProject);

    const [disable, setDisable] = React.useState<boolean>(true);
    const [openMaterials, setOpenMaterials] = React.useState<boolean>(false);

    const [openSubsector, setOpenSubsector] = React.useState<boolean>(false);

    const [disableStyle, setDisableStyle] = React.useState<string>('disable');

    const openModalMaterials = (e: React.MouseEvent<HTMLButtonElement>) => {
        setOpenMaterials(true);
    };
    const closeModalMaterial = () => {
        setOpenMaterials(false);
    };
    const handleCheckSubsector = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDisableStyle(disable ? '' : 'disable');
        setDisable(!disable);
    };
    const openModalSubsector = (e: React.MouseEvent<HTMLButtonElement>) => {
        setOpenSubsector(true);
    };
    const closeModalSubsector = (e: React.MouseEvent<HTMLButtonElement>) => {
        setOpenSubsector(false);
    };

    return (
        <div id='materials'>
            <div className='d-flex justify-content-center align-items-center mb-2'>
                <div></div>
                <Button classNameBtn='btn-materials' onClick={openModalMaterials}>
                    {t('material_bed_material_button')}
                </Button>

                {openMaterials && <FormikMaterial open={openMaterials} closeModal={closeModalMaterial} showSetMatForAll />}
            </div>
            <div className='d-flex justify-content-between align-items-center'>
                <Checkbox title={t('material_subsector')} name='subsector' disabled={project.data?.geometry?.some(sec => !sec.material?.id)} onChange={handleCheckSubsector} />
                <Button classNameBtn={`btn-materials ${disableStyle}`} onClick={openModalSubsector} disabled={disable}>
                    {t('material_create_subsector')}
                </Button>
                {openSubsector && <FormikSubsector open={openSubsector} closeModal={closeModalSubsector} />}
            </div>
        </div>
    );
};

export default Materials;
